// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__24o_h","footer":"ModalUpdate_footer__2ie8a"};